<template>
	<inertia-head title="Plan Details" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Plan Details</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Here are your subscription details.
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="block block-rounded">
			<div class="block-header text-center">
				<h3 class="block-title">CURRENT MEMBERSHIP</h3>
			</div>
			<div class="block-content bg-info-light text-center">
				<div class="h3 fw-bold mb-0">
					{{ user.current_rank }} {{ user.add_alias }}
				</div>
				<div v-if="is_lifetime" class="fs-sm fw-semibold mb-3">
					{{ user.current_rank }} LIFETIME
				</div>
				<div v-else class="fs-sm fw-semibold mb-3">
					Expiry: {{ user.expiry }}
				</div>
			</div>

			<div class="block-content block-content-full">
				<div v-if="!is_lifetime" class="form-group mb-3">
					<inertia-link v-if="!['PLATINUM FAITHFUL','FREE'].includes(user.current_rank)" href="/member/advance-renew" class="fs-xs btn btn-info"><i class="fa fa-arrow-circle-up me-2"></i>Advance Renew</inertia-link>
					<inertia-link v-if="['PLATINUM FAITHFUL'].includes(user.current_rank)" href="/member/upgrade" class="fs-xs btn btn-info"><i class="fa fa-arrow-circle-up me-2"></i>Upgrade your Membership</inertia-link>
				</div>
				<div class="form-group mb-3">
					<input v-model="query" type="search" class="form-control" />
				</div>
				<div class="table-responsive">
					<table class="table table-striped table-borderless table-vcenter">
						<thead>
							<tr>
								<th>#</th>
								<th>TxnID</th>
								<th>Date</th>
								<th>Membership</th>
								<th>Expiry</th>
								<th>Amount</th>
								<th>Method</th>
							</tr>
						</thead>
						<tbody class="fs-sm">
							<tr
								v-for="(opsRequest, index) in opsRequests.data"
								:key="opsRequest.txnid"
							>
								<td>{{ index + opsRequests.from }}</td>
								<td class="fw-semibold">{{ opsRequest.txnid }}</td>
								<td>{{ opsRequest.date }}</td>
								<td>
									<small>{{ opsRequest.course }}</small>
								</td>
								<td>{{ opsRequest.expiry }}</td>
								<td class="text-end">&#8369;{{ opsRequest.amount }}</td>
								<td class="fs-xs">{{ opsRequest.mop }}</td>
							</tr>
							<tr v-if="opsRequests.data.length == 0">
								<td colspan="7" class="text-center">NO DATA FOUND</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="pagination-container mt-3">
					<nav>
						<ul class="pagination pagination-sm justify-content-end">
							<li
								v-for="(link, key) in opsRequests.links"
								:key="key"
								class="page-item"
								:class="{ active: link.active, disabled: !link.url }"
							>
								<inertia-link
									class="page-link"
									:href="link.url"
									:only="['opsRequests']"
									v-html="link.label"
								/>
							</li>
						</ul>
					</nav>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

import debounce from 'lodash/debounce'
import { onMounted, ref, watch } from 'vue'
import { Inertia } from '@inertiajs/inertia'
import AuthLayout from '../../Layouts/AuthLayout'
import { createToaster } from '@meforma/vue-toaster'

export default {
	layout: AuthLayout,
	props: {
		flash: Object,
		user: Object,
		is_lifetime: Boolean,
		ops_lifetime: Object,
		opsRequests: Object,
		filters: Object,
	},
	setup(props) {

		const toast = createToaster();
		
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const query = ref(props.filters.query)

		watch(
			query,
			debounce(function (value) {
				Inertia.get(
					'plan-details',
					{ query: value },
					{
						replace: true,
						preserveState: true,
						preserveScroll: true,
						only: ['opsRequests', 'filters'],
					}
				)
			}, 500)
		)

		return {
			query,
		}
	},
}
</script>
